var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex w-100"},[(!_vm.details)?_c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"col-md-3"},[_c('filterRegister',{attrs:{"tipoFluxo":_vm.TipoQmaTemplate},on:{"search":_vm.search}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('collapseQma',{ref:"collap",attrs:{"tipoFluxo":_vm.TipoQmaTemplate}})],1)]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7606c46d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/qma/registerbasicQMA/registerbasicQmaLV/registerbasicQmaLV.vue
// module id = null
// module chunks = 